export const APP_VERSION = '347e76a';
